import { render, staticRenderFns } from "./BusinessUnitForm.vue?vue&type=template&id=a2451c40&"
import script from "./BusinessUnitForm.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports